<template>
  <div class="wrapper">
    <template v-if="showPage">
    <!-- 日期选择 -->
    <div class="date-select">
      <h2><span>*</span>预订时段</h2>
      <!-- 切换日期 -->
      <div class="dateBox">
        <div class="box_left" :style="{'marginLeft':'-'+scrollLeft}">
          <div
            :class="['scroll_data_item',item.date == activeDate?'cur_item':'']"
            v-for="(item,index) in selectDataArr"
            :key="index"
            @click="selectDate(item.date)"
          >
            <span v-if="index==0" class="item_t">今天</span>
            <span v-else-if="index==1" class="item_t">明天</span>
            <span v-else class="item_t">{{item.week}}</span>
            <span class="item_b">{{item.day}}</span>
            <span class="item_ll" v-if="item.date == activeDate"></span>
          </div>
        </div>
        <!-- 选择日期 -->
        <div v-if="false" class="select_data border-left" @click.stop="changeDate">
          <img class="dateIcon" src="../../../assets/images/icon_arrows_unfold.png" />
        </div>
      </div>
      <!-- 选择时间 -->
      <div class="date-select-form" v-if="timeList.length">
        <div
          v-for="(item,index) in timeList"
          :key="index"
          :class="['date-select-form-row',(selectStart < index&&selectEnd > index)?'betweenn':'']"
        >
          <div class="betweenBg">
            <div class="startBgg" v-if="selectStart == index"></div>
            <div class="endBgg" v-if="selectEnd == index"></div>
            <div
              :class="['date-select-form-item',selectStart==index?'startt':'',selectEnd==index?'endd':'']"
              @click="selectBetween(index,item.status)"
            >
              <span
                :class="['time',item.status=='1'||(index>0&&timeList[index-1].status == '1')?'keyi':'']"
                v-if="selectStart!=index&&selectEnd!=index"
              >{{item.time}}</span>
              <span class="timeText" v-if="selectStart==index&&selectStart!=selectEnd">{{item.time}}</span>
              <span class="timeText" v-if="selectEnd==index&&selectStart!=selectEnd">{{item.time}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 会议主题 -->
    <div class="room_theme">
      <h2><span>*</span>会议主题</h2>
      <textarea placeholder="请输入会议主题" @blur="blur" v-model='theme' @input="textareaInput" maxlength="15"></textarea>
    </div>
    <!-- 底部按钮 -->
    <footer class="footer_box">
      <p @click="appointSubmit" :class="[canClick?'canClick':'']">立即预订</p>
    </footer>
  </template>
  </div>
</template>
<script>
import util from "../../../utils/util";
import { mapState } from "vuex";
import { getMeetingBookList } from "../../../utils/api";
export default {
  name: "roomDate",
  components: {
  },
  data() {
    return {
      id:'',
      canClick:false,
      timeList: [], //时间列表
      betweenArray: [],
      selectStart: 9999,
      selectEnd: 9999,
      hourCount: 0,
      scrollLeft: 0,
      dataList:[],
      activeWeekDay: "",
      selectDataArr: [], //可选日期数组
      reserveTime: "", //可以预订几天，如果没有，默认可预订未来一个月
      activeDate: util.formatTime(new Date(), 4),
      date: util.formatTime(new Date(), 4),
      showPage:false,
      theme:''//主题
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.id = this.$route.query.id;
    this.activeWeekDay = "周" + this.getWeek(this.activeDate);
    this.getMeetingBookList();
  },
  activated() {
    if(this.common.isChange){
      this.$router.replace("/smartOffice/meetingAppoint")
    }
  },
  methods: {
    blur(){
      setTimeout(function(){
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    textareaInput(){
      this.canClickFun()
    },
    canClickFun(){
      if(this.theme && this.selectEnd != 9999 && this.selectStart != 9999){
        this.canClick = true;
      }else{
        this.canClick = false;
      }
    },
    // 日期获取周几
    getWeek(value) {
      let end = ''
      switch (
        new Date(value.replace(new RegExp(/-/gm), "/") + " 00:00:00").getDay()
      ) {
        case 1:
          end = "一";
          break;
        case 2:
          end = "二";
          break;
        case 3:
          end = "三";
          break;
        case 4:
          end = "四";
          break;
        case 5:
          end = "五";
          break;
        case 6:
          end = "六";
          break;
        case 0:
          end = "日";
          break;
        default:
      }
      return end
    },
    selectBetween(index, status) {
      let that = this;
      let len = that.betweenArray.length;
      let statusPre = "";
      if (index > 0) {
        statusPre = this.timeList[index - 1].status;
      }
      // length小于2   push
      // length大于等于2  取最大和最小
      if (status == 1 || index > 0 && statusPre == "1") {
        if (len == 0) {
          let betweenArray = that.betweenArray;
          betweenArray.push(index);
          that.betweenArray = betweenArray;
          that.selectStart = index;
        } else if (len == 1 && index != that.betweenArray[0]) {
          this.checkMeetingTime(index);
        } else if (len == 2) {
          let betweenArray = [];
          betweenArray.push(index);
          that.selectEnd = 9999;
          that.betweenArray = betweenArray;
          that.selectStart = index;
        }
        this.canClickFun()
      } else {
        util.showToast("当前时间不可预订");
      }
    },
    selectDate(data) {
      this.activeDate = data;
      this.pretermission = false; //是否选中免额时长
      this.companyList = []; //可享受免费时长的公司列表
      this.activeCompany = ""; //选中的公司名字
      this.activeCompanyObj = {};
      this.freeTime = 0; //面额时长
      this.betweenArray = [];
      this.selectStart = 9999;
      this.selectEnd = 9999;
      this.totalPrice = "";
      this.minPrice = 0;
      // this.timeList = "";
      this.activeWeekDay = "周" + this.getWeek(data);
      this.getMeetingBookList();
    },
    checkMeetingTime(index) {
      let that = this;
      // let selectHours = Math.abs(that.betweenArray[0] - index) / 2; //选择的时长
      // console.log(selectHours)
      let betweenArray = that.betweenArray;
      betweenArray.push(index);
      that.betweenArray = betweenArray;
      that.selectStart = Math.min(that.betweenArray[0], index);
      that.selectEnd = Math.max(that.betweenArray[0], index);
    },
    getMeetingBookList() {
      let that = this;
      util.showLoading();
      getMeetingBookList({
        meetingRoomId: this.id,
        date: this.activeDate
      }).then(res => {
        util.hideLoading();
        console.log(res);
        this.showPage = true;
        if (res.res && res.res.code === 10000 && res.body) {
          this.getSelectDataArr(res.body.reserveTime);
          if (res.body.respOutputs) {
            that.timeList = res.body.respOutputs;
          } else {
            this.timeList = '';
            util.showToast("当前没有可预订时段");
          }
        } else {
          this.timeList = '';
          util.showToast(res.res.msg);
        }
      });
    },
    // 得到可选时间日期
    getSelectDataArr(val) {
      let arr = [];
      if (val == 0 || val) {
        for (var i = 0; i < val + 1; i++) {
          arr.push({
            date: util.targetDay(i, "date"),
            week: this.getWeek(util.targetDay(i, "date")),
            day: util.targetDay(i, "day")
          });
        }
      } else {
        for (var i = 0; i < 30; i++) {
          arr.push({
            date: util.targetDay(i, "date"),
            week: this.getWeek(util.targetDay(i, "date")),
            day: util.targetDay(i, "day")
          });
        }
      }
      this.selectDataArr = arr;
    },
    // 去结算
    appointSubmit() {
      let that = this;
      if(!this.canClick){
        return false;
      }
      let timeList = that.timeList;
      for (let i = 0; i < timeList.length; i++) {
        if (i > that.selectStart - 1 && i < that.selectEnd) {
          if (timeList[i].status != "1") {
            util.showToast("当前选择包含不可预订时段");
            return;
          }
        }
      }
      this.$router.push({
        path:`/smartOffice/roomConfirm?id=${this.id}&timeList=${JSON.stringify(this.timeList)}&activeWeekDay=${this.activeWeekDay}&selectStart=${this.selectStart}&selectEnd=${this.selectEnd}&selectDay=${this.activeDate}&hour=${this.hourCount}&theme=${this.theme}`
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.wrapper {
  background: @colore;
}
h2{
  padding:28px 0 28px 20px;
  line-height:50px;
  font-size:36px;
  font-weight:bold;
  color:rgba(24,24,24,1);
  .flex();
  align-items: flex-start;
  span{
    color:#FC3F56;
    font-size:28px;
    margin-right:4px;
    line-height: 1;
    margin-top:6px;
  }
}
/*切换选择*/
.date-select {
  background: #fff;
}
.dateBox {
  height:100px;
  .flex();
  width: 100%;
  align-items: center;
  overflow: hidden;
  margin-bottom:10px;
  box-shadow:0px 8px 10px 0px rgba(0,0,0,0.06);
}
.box_left {
  height: 100px;
  .flex();
  flex: 1;
  flex-wrap: nowrap;
  align-items: center;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.scroll_data_item {
  width: 100px;
  height: 100px;
  display: block;
  position: relative;
  text-align: center;
  overflow: hidden;
  flex-shrink: 0;
}
.scroll_data_item span {
  display: block;
}
.cur_item{
  .item_t{
    color:#333;
    font-weight:bold;
  }
  .item_b{
    color:#333;
    font-weight:bold;
  }
}
.item_t {
  font-size: 24px;
  color: rgba(102, 102, 102, 1);
  line-height: 34px;
  margin-top: 16px;
}
.item_b {
  height: 34px;
  font-size: 24px;
  color: rgba(102, 102, 102, 1);
  line-height: 34prx;
}
.item_ll {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  width: 32px;
  height: 6px;
  background: @color17;
}
.select_data {
  position: relative;
  height: 88px;
  width: 88px;
  .flex();
  justify-content: center;
  align-items: center;
}
.picker span {
  height: 60px;
  font-size: 44px;
  color: rgba(51, 51, 51, 1);
  line-height: 60px;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  bottom: 0;
  opacity: 0;
}
.dateIcon {
  width: 32px;
  height: 32px;
  display: block;
}
/*时段选择*/

.date-select-form {
  justify-content: flex-start;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  padding-top: 12px;
}

.date-select-form-row {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 107px;
  margin-bottom: 12px;
}

.betweenBg {
  width: 107px;
  height: 76px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
}

.startBgg {
  width: 60px;
  height: 76px;
  position: absolute;
  left: 53px;
  background-color: #f1f4fd;
}

.endBgg {
  width: 60px;
  height: 76px;
  position: absolute;
  right: 53px;
  background-color: #f1f4fd;
}

.date-select-form-item {
  width: 84px;
  height: 84px;
  border-radius: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.startt {
  background-color: @color17;
  position: relative;
  z-index: 2;
}

.endd {
  background-color: @color17;
  position: relative;
  z-index: 2;
}

.time {
  font-size: 28px;
  color: rgba(51, 51, 51, 0.3);
}

.timeText {
  font-size: 28px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
}

.timeTextS,
.timeTextE {
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}
.switch{
  // background:@color17 !important;
  // border-color:@color17 !important;
}
.betweenn {
  background-color: #EFF1FC;
}

.keyi {
  color: #333;
}

.submit_bottom {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;right:0;
  height: 108px;
  padding-left: 40px;
  padding-right: 20px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(234, 234, 234, 1);
}
.bottom_isIpx {
  padding-bottom: 68px;
}

.submitCompanyLeft {
  justify-content: center;
}

.submitCompanyLeftTop {
  flex-direction: row;
  display: flex;
  align-items: flex-end;
  height: 44px;
}

.submitLeft {
  flex-direction: row;
  display: flex;
  align-items: flex-end;
  height: 56px;
}

.submitSumText {
  font-size: 28px;

  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}

.submit_btn {
  width: 192px;
  height: 68px;
  background-color: @color17;
  border-radius: 4px;
  font-size: 28px;
  color: rgba(255, 255, 255, 1);
  line-height: 68px;
  text-align: center;
}
.unClick {
  background-color: #eaeaea;
  color: #999;
  // margin-left: 498px;
}
/*日期选择控件*/

.box {
  position: fixed;
  bottom: 108px;
  left: 0;right:0;
  margin: 20px;
  background: #fff;
  z-index: 2;
  padding: 32px 28px 14px 28px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #eaeaea;
}
.box_isIpx {
  bottom: 176px;
}
.msgBox {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  width: 100%;
  margin-bottom: 18px;
}

.freeBox {
  flex-direction: row;
  display: flex;
  margin-bottom: 18px;
  justify-content: space-between;
  align-items: center;
}

.msgLeft,
.msgRight {
  flex-direction: row;
  display: flex;
  align-items: center;
  height: 36px;
}

.label {
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
  margin-right: 20px;
}

.timeInterval {
  font-size: 24px;

  color: rgba(153, 153, 153, 1);
  line-height: 36px;
}

.chinese {
  font-size: 26px;

  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}

.yjt {
  width: 15px;
  height: 26px;
  margin-left: 19px;
}

.submitNum {
  font-size: 32px;

  color: #fc3f56;
  line-height: 40px;
  margin-left: 8px;
}

.FreeLine {
  font-size: 24px;
  color: rgba(252, 63, 86, 1);
  line-height: 36px;
  padding-left: 70px;
}

.exempt {
  font-size: 24px;
  color: @color17;
  line-height: 36px;
}

.pretermissionBox {
  width: 112px;
  height: 56px;
  border-radius: 28px;
  border-top-width: 4px;
  border-bottom-width: 4px;
  border-left-width: 4px;
  border-right-width: 4px;
  border-top-color: rgba(218, 218, 218, 1);
  border-bottom-color: rgba(218, 218, 218, 1);
  border-left-color: rgba(218, 218, 218, 1);
  border-right-color: rgba(218, 218, 218, 1);
  justify-content: center;
}

.pretermissionIcon {
  margin-left: 10px;
  width: 36px;
  height: 36px;
  background-color: rgba(218, 218, 218, 1);
  box-shadow: 0px 4px 8px 0px rgba(231, 231, 231, 0.5);
  border-radius: 100%;
}

.pretermissionActiveBox {
  width: 112px;
  height: 56px;
  border-radius: 28px;
  border-top-width: 4px;
  border-bottom-width: 4px;
  border-left-width: 4px;
  border-right-width: 4px;
  border-top-color: #00bdff;
  border-bottom-color: #00bdff;
  border-left-color: #00bdff;
  border-right-color: #00bdff;
  justify-content: center;
  align-items: flex-end;
}

.pretermissionActiveIcon {
  margin-right: 10px;
  width: 36px;
  height: 36px;
  background-color: @color17;
  box-shadow: 0px 4px 8px 0px rgba(231, 231, 231, 0.5);
  border-radius: 100%;
}
.valueBox {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.valueBox img {
  display: block;
  width: 15px;
  height: 26px;
  margin-left: 19px;
}
.tui-picker-detail {
  font-size: 26px;
  color: #333;
}
// 会议主题
.room_theme{
  background:#fff;
  margin-top:14px;
  margin-bottom:120px;
  textarea{
    font-size:44px;
    padding:0 40px;
    width:100%;
    box-sizing:border-box;
    min-height:154px;
  }
}
.footer_box{
  position:fixed;
  bottom:0;right:0;left:0;
  background:#fff;
  padding:16px 20px;
  box-sizing: border-box;
  p{
    height:88px;
    background:rgba(218,218,218,1);
    border-radius:8px;
    text-align: center;
    line-height:88px;
    font-size:32px;
    color:rgba(255,255,255,1);
    &.canClick{
      background:#1740DA;
    }
  }
}
</style>